import { useTheme } from '@mui/styles';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export interface IFeaturesContext {
    authentication: ApplicationMuiTheme['app']['clientTheme']['features']['Authentication'];
    isSSOEnabled: boolean;
    fireblocks: {
        api: boolean;
    };
    liquidityFacility: boolean;
}

export const useFeatures = (): [IFeaturesContext] => {
    const theme = useTheme<ApplicationMuiTheme>();

    return [
        {
            authentication: theme?.app?.clientTheme.features.Authentication,
            isSSOEnabled: theme?.app?.clientTheme.features.Authentication.SSO ?? false,
            fireblocks: { api: theme?.app?.clientTheme.features.Fred?.Fireblocks.API ?? false },
            liquidityFacility: theme?.app?.clientTheme.features.LiquidityFacility ?? false
        }
    ];
};